































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  @Prop()
  private url: any;
  @Prop()
  private ifShow: any;
  @Watch("ifShow", { immediate: true })
  private ifShowChange() {
    this.visible = this.ifShow;
  }
  private visible: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private download() {
    // 假设 url 是要下载的文件URL
    const fileUrl =
      this.systemInfo.GLOBAL_API_ROOT +
      "api/system/file/download_file/?url=" +
      encodeURIComponent(this.url);

    // 使用 window.open 来下载文件，但这通常用于下载非Blob资源的文件
    // 注意：这种方法可能会受到浏览器安全策略的限制，特别是当涉及到跨域请求时
    // window.open(fileUrl, '_blank'); // 如果服务器直接返回文件流，这种方法可能有效

    // 更可靠的方法是使用 fetch 和 Blob
    fetch(fileUrl, {
      method: "GET", // 对于下载，通常使用 GET 方法
      headers: {
        // 如果服务器需要特定的请求头，可以在这里添加
        // 例如，如果服务器需要验证令牌，可以添加 'Authorization': 'Bearer your_token'
      },
      // 注意：GET 请求通常不包含 body
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok.");
        }
        return response.blob(); // 将响应体转换为 Blob
      })
      .then((blob) => {
        // 创建一个临时的URL来引用Blob
        const url = window.URL.createObjectURL(blob);
        // 创建一个a标签来模拟点击下载
        const a = document.createElement("a");
        a.href = url;
        // 获取当前时间戳来生成唯一的文件名（可选）
        const timestamp = Date.now();
        const filename = `${timestamp}.jpg`; // 或者您可以使用文件原有的名称
        a.download = filename; // 设置下载后的文件名
        document.body.appendChild(a);
        a.click(); // 触发下载
        document.body.removeChild(a); // 下载后立即移除a标签
        window.URL.revokeObjectURL(url); // 释放由createObjectURL创建的URL对象
      })
      .catch((error) => {
        console.error(
          "There has been a problem with your fetch operation:",
          error
        );
      });
  }
  private cancel() {
    this.$emit("cancel");
  }
}
